module.exports = __webpack_public_path__ + "static/media/7.67164e58.png";